import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

export const getDisplaySettingSystem = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.DISPLAY_SETTING_SYSTEM, null, true, isCatchHandled);
  return response;
};

export const postSettingSystem = async (
  {hostName, organization, isAutoTimezone, isAutoDateTime, timezone, date, time},
  isCatchHandled = false,
) => {
  const data = {
    HostName: hostName,
    Organization: organization,
    AutoTimezone: {
      Enable: isAutoTimezone,
    },
    AutoDatetime: {
      Enable: isAutoDateTime,
    },
    Timezone: timezone,
    DateTime: {
      Date: date,
      Time: time,
    },
  };

  const response = await axiosMethods.post(RestAPI.SET_SYS_SETTING_SYSTEM, data, null, true, isCatchHandled);
  return response;
};

export const getAutoTimeZoneSystem = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.GET_AUTO_TIME_ZONE_SYSTEM, null, true, isCatchHandled);
  return response.data;
};

export const getDateTimeLocalSystem = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.GET_DATE_TIME_LOCAL_SYSTEM, null, true, isCatchHandled);
  return response.data;
};

export const getDateTimeServerSystem = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.GET_DATE_TIME_SERVER_SYSTEM, null, true, isCatchHandled);
  return response.data;
};

export const getTimeZoneAreasSystem = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.GET_TIME_ZONE_AREAS_SYSTEM, null, true, isCatchHandled);
  return response.data;
};

export const postTimeZoneRegionsSystem = async (timezoneArea, isCatchHandled = false) => {
  const data = {
    TimezoneArea: timezoneArea,
  };

  const response = await axiosMethods.post(RestAPI.GET_TIME_ZONE_REGIONS_SYSTEM, data, null, true, isCatchHandled);
  return response.data;
};

export const getDevicePropsSystem = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.DEVICE_PROPS_SYSTEM, null, true, isCatchHandled);
  return response.data;
};

export const getHWPropsSystem = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.HARDWARE_PROPS_SYSTEM, null, true, isCatchHandled);
  return response.data;
};

export const getInfoSystem = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.INFO_SYSTEM, null, true, isCatchHandled);
  return response;
};
